/* W&C: infinite scroll for collection and search grids. Loads the next page when the pager comes near the
   viewport and appends its cards to the grid. The pager stays in the HTML (and works without JavaScript). */
(function () {
  var loading = false;
  function pager() { return document.querySelector('#ProductGridContainer .pagination-wrapper, #ProductGridContainer nav.pagination'); }
  function nextUrl(root) {
    var a = (root || document).querySelector('.pagination__item--prev[href], a.pagination__item-arrow[aria-label*="Next" i]');
    return a ? a.href : null;
  }
  function loadMore() {
    if (loading) return;
    var url = nextUrl();
    var grid = document.getElementById('product-grid');
    if (!url || !grid) return;
    loading = true;
    grid.classList.add('wc-loading');
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('#product-grid > li');
        items.forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
        var oldP = pager(), newP = doc.querySelector('#ProductGridContainer .pagination-wrapper, #ProductGridContainer nav.pagination');
        if (oldP && newP) oldP.replaceWith(document.importNode(newP, true)); else if (oldP) oldP.remove();
        if (!nextUrl()) { var p = pager(); if (p) p.remove(); }
      })
      .catch(function () {})
      .finally(function () { loading = false; grid.classList.remove('wc-loading'); check(); });
  }
  function check() {
    var p = pager();
    if (!p || !nextUrl()) return;
    if (p.getBoundingClientRect().top < window.innerHeight + 900) loadMore();
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; check(); });
  }, { passive: true });
  window.addEventListener('resize', check);
  document.addEventListener('DOMContentLoaded', check);
  check();
})();
